import { composeWithDevTools } from '@redux-devtools/extension'
import { applyMiddleware, compose, legacy_createStore } from 'redux'
import { thunk } from 'redux-thunk'

import { isDevEnv } from '../settings/environment.config'
import { rootReducer } from './reducers.config'

/**
 * Creates a Redux store factory with development tools integration.
 */
const factoryStore = (initialState = {}) => {
  const composeEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 5
  })

  const middleware = isDevEnv
    ? composeEnhancers(applyMiddleware(thunk))
    : compose(applyMiddleware(thunk))

  const store = legacy_createStore(rootReducer, initialState, middleware)

  return () => store
}

/**
 * Singleton store instance for the application.
 *
 * This ensures a single Redux store exists throughout the app lifecycle,
 * preventing multiple store instances and maintaining state consistency.
 */
export const storeSingleton = factoryStore()
